import { RouteConfig } from 'vue-router';
import ListLayoutTest from './pages/ListLayoutTest.vue';

export default [
    {
        path: '/:tenantId/list-layout-test',
        name: 'ListLayoutTest',
        component: ListLayoutTest,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            checkLicence: false,
            title: 'ListLayout - Test',
        },
    },
] as RouteConfig[];
